import { createContext } from 'react';

import type { ConfigContextTypes } from './types';

// @ts-ignore
export default createContext<ConfigContextTypes>(null);
